import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { FileUploader } from "../../core/uploader/file-upload";
import { AuthService } from "../shared/services/auth.service";
import { ConfigurationService } from "../shared/services/configuration.service";

@Injectable()
export class UploaderService {
  private ePermitsUrl = " ";
  private videoInductionUrl = " ";

  constructor(
    private configurationService: ConfigurationService,
    private authService: AuthService,
    private http: HttpClient,
  ) {
    if (this.configurationService.isReady) {
      this.ePermitsUrl = this.configurationService.serverSettings.ePermitsUrl;
      this.videoInductionUrl =
        this.configurationService.serverSettings.videoInductionUrl;
    } else {
      this.configurationService.settingsLoaded$.subscribe(
        (x) => (
          (this.ePermitsUrl =
            this.configurationService.serverSettings.ePermitsUrl),
          (this.videoInductionUrl =
            this.configurationService.serverSettings.videoInductionUrl)
        ),
      );
    }
  }

  getFileUploader(
    resourceUrl: string,
    id: number,
    isVideo?: boolean,
  ): FileUploader {
    let url = `${this.ePermitsUrl}/api/v1/${resourceUrl}`;
    if (isVideo) {
      url = `${this.videoInductionUrl}/api/v1/${resourceUrl}`;
    }

    return new FileUploader({
      url: url,
      queueLimit: 1,
      autoUpload: true,
      authToken: "Bearer " + this.authService.accessToken,
      authTokenHeader: "Authorization",
      headers: this.authService.buildUploaderHeaders(),
      additionalParameter: { id: id },
    }, this.http);
  }
}
